import { RHFTextField } from './rhf-text-field';
import { RHFUploadBox } from './rhf-upload';

export const Field = {
  Text: RHFTextField,
  UploadBox: RHFUploadBox,
};